<div class="categories-subcategories-selector">
    @if (isSpecialCollection) {
        <div [class.is-rtl]="isRtl$ | async" class="category-limited">
            <category-sub-categories-special
                [categoryName]="categoryName | translate"
                [showFilters]="showFilters"
                [siblingCategories]="siblingCategories"
                [currentCategoryFromABTest]="currentCategoryFromABTest"
                [lastSectionTranslated]="lastSectionTranslated$$()"
                [showDebugCategoryIds]="showDebugCategoryIds$$()"
                [direction]="direction$$()"
                [selectGridView]="selectGridView"
                [showCategoryTitle]="showCategoryTitle"
                [subCategories]="subCategories"
            >
            </category-sub-categories-special>
        </div>
    } @else {
        <div [class.is-rtl]="isRtl$ | async" class="category-default">
            <category-sub-categories-default
                [categoryName]="categoryName | translate"
                [showFilters]="showFilters"
                [siblingCategories]="siblingCategories"
                [currentCategoryFromABTest]="currentCategoryFromABTest"
                [lastSectionTranslated]="lastSectionTranslated$$()"
                [showDebugCategoryIds]="showDebugCategoryIds$$()"
                [direction]="direction$$()"
                [selectGridView]="selectGridView"
                [filtersArray]="filtersArray"
                [navigationCategoriesOptions]="navigationCategoriesOptions"
                [isNormalBehavior]="isNormalBehavior"
                [filterTypeUsed]="filterTypeUsed"
                (updateFilterEmitter)="updateFilter($event)"
            >
            </category-sub-categories-default>
        </div>
    }
</div>
